import React,{useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';

const ProtectedRoute = ({ component: Component,...rest }) => {
  const uid=reactLocalStorage.get("uid")
  const msisdn=reactLocalStorage.get("msisdn")
  const userStatus=reactLocalStorage.get("subStatus")
  const wasCheckSubDone=localStorage.getItem("wasCheckSubDone")
  let  isAuthenticated  = (msisdn && wasCheckSubDone && userStatus==="active")?true:false; 
  console.log("msisdn,userStatus::::",msisdn,userStatus)
  
  return (
    <Route
      {...rest}
      render={(routeProps) =>
        isAuthenticated ? 
            <Component {...routeProps} /> 
  
         : (
          <Redirect to="/subs" />
        )
      }
    />
  );
};

export default ProtectedRoute;
